import { useState } from "react";
import { hotTopics } from "@/mocks/homeData";

const cloudTags = [
  "人设争议", "恋情曝光", "合约纠纷", "公司声明", "舆论反转", "道歉原文",
  "品牌解约", "税务疑云", "旧照考古", "直播翻车", "综艺事故", "翻红回归",
  "资源变动", "粉丝管理", "录音疑云", "版权争议", "赛道复盘", "行业整改",
];

export default function Trending() {
  const [active, setActive] = useState(hotTopics[0].rank);

  return (
    <section id="trending" className="shell-wrap py-14 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="section-eyebrow">
            <i className="ri-flashlight-fill" /> 今日热议
          </p>
          <h2 className="title-serif mt-2 text-2xl font-black md:text-4xl">91黑料 话题墙</h2>
          <p className="mt-2 max-w-2xl text-sm text-ink/60 md:text-base">
            按人物、事件与时间线整理的当日热搜与常青话题，点选任一条可查看归纳口径。
          </p>
        </div>
        <span className="inline-flex items-center gap-2 rounded-full border border-ink/10 bg-paper px-4 py-2 text-xs text-ink/60">
          <i className="ri-time-line text-ember" /> 每小时自动重排
        </span>
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        {/* ranked list */}
        <div className="space-y-3">
          {hotTopics.map((t, idx) => {
            const isActive = active === t.rank;
            return (
              <button
                key={t.rank}
                type="button"
                onClick={() => setActive(t.rank)}
                className={
                  "group w-full rounded-xl border px-4 py-3.5 text-left transition-all cursor-pointer " +
                  (isActive
                    ? "border-ember bg-ember text-white"
                    : "border-ink/10 bg-paper hover:border-ember/40")
                }
              >
                <div className="flex items-center gap-3">
                  <span
                    className={
                      "title-serif w-8 shrink-0 text-left text-lg font-black " +
                      (isActive ? "text-white" : "text-ember")
                    }
                  >
                    {t.rank}
                  </span>
                  <span className="flex-1 truncate text-sm font-semibold md:text-base">
                    {t.label}
                  </span>
                  {t.tag && (
                    <span
                      className={
                        "whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold " +
                        (isActive ? "bg-white/20 text-white" : "bg-ember/10 text-ember")
                      }
                    >
                      {t.tag}
                    </span>
                  )}
                  <span className="hidden w-24 sm:block">
                    <span className="mb-1 flex justify-between text-[10px] text-ink/45">
                      <span>热度</span>
                      <span>{t.hot}</span>
                    </span>
                    <span
                      className={
                        "block h-1.5 overflow-hidden rounded-full " +
                        (isActive ? "bg-white/25" : "bg-ink/10")
                      }
                    >
                      <span
                        className={
                          "block h-full rounded-full " +
                          (isActive ? "bg-white" : "bg-ember")
                        }
                        style={{ width: `${t.hot}%` }}
                      />
                    </span>
                  </span>
                  <span className={isActive ? "text-white" : "text-ink/30"}>
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
                {isActive && (
                  <p className="anchor-panel mt-2.5 border-t border-white/20 pt-2.5 text-xs leading-relaxed text-white/80 md:text-sm">
                    已按人物 / 事件 / 时间线归入相应档案，附声明与回应版本对照，便于快速交叉查阅。
                  </p>
                )}
              </button>
            );
          })}
        </div>

        {/* tag cloud wall */}
        <div className="flex flex-col rounded-2xl border border-ink/10 bg-paper p-5 md:p-6">
          <div className="flex items-center justify-between">
            <p className="title-serif text-lg font-black">常青话题墙</p>
            <span className="text-xs text-ink/45">{cloudTags.length} 个标签</span>
          </div>
          <p className="mt-1 text-xs leading-relaxed text-ink/55">
            单击标签可预筛对应合集，页面模块命名与分区均围绕这些方向组织。
          </p>
          <div className="mt-5 flex flex-wrap gap-2.5">
            {cloudTags.map((t) => (
              <span
                key={t}
                className="tag-chip border-ink/10 bg-cream text-ink/75 hover:border-ember hover:bg-ember hover:text-white"
              >
                # {t}
              </span>
            ))}
          </div>
          <div className="mt-auto pt-6">
            <div className="hairline h-px" />
            <p className="mt-4 flex items-center gap-2 text-xs text-ink/55">
              <i className="ri-question-line rounded-full bg-ember/10 p-1 text-ember" />
              更多词条见底部常见问题说明
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}